<template>
  <div class="account-management">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-user"></i> 账号列表</h2>
        <button class="btn btn-primary" @click="openLogin">添加账号</button>
      </div>
      <div class="account-list">
        <div class="account-list-item" v-for="(account, index) in accounts" :key="account.id"
             :class="{ 'is-current': account.is_select }">
          <div class="account-index">{{ (queryForm.page - 1) * queryForm.limit + index + 1 }}</div>
          <div class="account-avatar">
            <img :src="account.avatar" :alt="account.nickname">
          </div>
          <div class="account-info">
            <h3 class="account-name">{{ account.nickname }}</h3>
            <span v-if="account.is_select" class="current-account-tag">
              <i class="fas fa-check-circle"></i>
              当前账号
            </span>
          </div>
          <div class="account-actions">
            <button class="btn btn-danger" @click="deleteAccount(account.id)">删除</button>
            <button class="btn btn-success" v-if="!account.is_select" @click="switchAccount(account.id)">切换</button>
            <button class="btn btn-primary" v-else @click="openConnectModal(account)">{{liveWs ? '已连接' :  '连接直播间'}}</button>
          </div>
        </div>
        <div class="account-list-item" style="text-align: center;display: block;color:#adadad;"
             v-if="accounts.length<=0">
          暂无直播账号
        </div>
      </div>

      <div class="pagination-container">
        <div class="pagination">
          <button class="page-btn" @click="handleCurrentChange(queryForm.page - 1)" :disabled="queryForm.page === 1">
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="page-info">
            第 {{ queryForm.page }} 页，共 {{ queryForm.pageCount }} 页
          </div>
          <button class="page-btn" @click="handleCurrentChange(queryForm.page + 1)"
                  :disabled="queryForm.page >= queryForm.pageCount">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 连接直播间弹窗 -->
    <div v-if="showConnectModal" class="modal-overlay" @click.self="showConnectModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">连接直播间</h3>
          <button class="modal-close" @click="showConnectModal = false">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">直播间链接</label>
            <input
                type="text"
                v-model="liveUrl"
                @keyup="saveData('liveUrl')"
                class="form-input"
                placeholder="请输入直播间链接"
                autocomplete="off"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showConnectModal = false">取消</button>
          <button class="btn btn-primary" @click="saveLiveUrl" :disabled="isLoading">
            <span v-if="!isLoading">保存并启动</span>
            <span v-else>保存中...</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import http from "@/utils/http";
import {parseUrl} from "@/utils/function";


export default {
  name: 'AccountManagement',
  data() {
    return {
      newAccount: {
        name: '',
        avatar: '',
        fans: 0,
        views: 0,
        status: '未直播'
      },

      queryForm: {
        limit: 4,
        page: 1,
        pageCount: 0,

      },
      accounts: [],
      showConnectModal: false,
      liveUrl: '',
      currentAccount: null,
      isLoading: false,
      wsUrl: null,
    }
  },
  computed:{

    liveWs(){
      return this.$store.state.liveWs ? true : false
    }

  },

  mounted() {


    const liveUrl=localStorage.getItem("liveUrl");

    this.liveUrl = liveUrl || this.$store.state.liveUrl;
    window.addPlatform = this.addPlatform;
    this.getPlatformList();

  },
  methods: {
    async saveData(type){
      localStorage.setItem(type,this[type])

    },
    openConnectModal(account) {
      this.currentAccount = account;

      this.showConnectModal = true;
    },
    wsinit() {
      const account = this.accounts.find(item => item.is_select == 1);

      const ws = this.$store.state.liveWs;
      ws.onopen = () => {
        console.log(111)
      }
      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);

        switch (account.type) {
          case "douyin":
            switch (data.method) {
              case "WebcastChatMessage":
                console.log(data);
                // 消息
                if (this.$store.state.userInfo.platform.nickname != data.user.nickname) {
                  this.$store.commit("setLiveData", {
                    type: "messageData",
                    data: {
                      nickname: data.user.nickname,
                      content: data.content,
                    }
                  })

                }

                break;
              case "WebcastMemberMessage":
                // 进入直播间
                if (this.$store.state.userInfo.platform.nickname != data.user.nickname) {

                  this.$store.commit("setLiveData", {
                    type: "room_nickname",
                    data: data.user.nickname
                  })
                }
                break;
              case "WebcastRoomStatsMessage":
                this.$store.commit("setLiveData", {
                  type: "userCount",
                  data: data.total
                })
                break;
            }

            break;
          case "tiktok":


            switch (data.type) {
              case "chat":
                // 消息
                if (this.$store.state.userInfo.platform.nickname != data.user.nickname) {
                  this.$store.commit("setLiveData", {
                    type: "messageData",
                    data: {
                      nickname: data.user.nickname,
                      content: data.comment,
                    }
                  })

                }
                break;
              case "member":
                // 进入直播间
                if (this.$store.state.userInfo.platform.nickname != data.user.nickname) {
                  this.$store.commit("setLiveData", {
                    type: "room_nickname",
                    data: data.user.nickname
                  })
                }
                break;
              case "roomUser":


                this.$store.commit("setLiveData", {
                  type: "userCount",
                  data: data.viewerCount
                })
                break;
            }


            break;
        }
      }

    },
    async saveLiveUrl() {
      if (!this.liveUrl) {
        this.$dialog.tips({message: '请输入直播间链接', type: 'error'});
        return;
      }
      const account = this.accounts.find(item => item.is_select == 1);


      const res=await http.post("api/live/parseUrl",{url:this.liveUrl});


      const jx = await parseUrl(account.type, this.liveUrl);

      if (res.code==200) {
        this.$store.commit("setliveUrl", this.liveUrl)
        if (this.$store.state.liveWs) {
          this.$store.state.liveWs.close();
        }
        var ws = new WebSocket(res.data)
        this.$store.commit("setliveWs", ws);
        this.wsinit();
        this.showConnectModal = false;
        this.$dialog.tips({message: res.msg, type: 'success'});

        return;
      }
      this.$dialog.tips({message: res.msg, type: 'error'});


    },
    async getPlatformList() {

      const res = await http.post("api/platform/list", this.queryForm)

      this.accounts = res.data.list;

      this.queryForm.pageCount = res.data.pageCount


    },

    async addPlatform(cookie) {
      const res = await http.post("api/user/addPlatform", {cookie});
      if (res.code == 200) {
        this.getPlatformList();
        this.$dialog.tips({message: res.msg, type: "success"})
      } else {
        this.$dialog.tips({message: res.msg, type: "error"})

      }

    },

    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getPlatformList();
    },
    async deleteAccount(id) {

      const confirm = await this.$dialog.confirm({
        title: '温馨提示',
        message: '确定要删除这个账号？'
      }).catch(() => false);

      if (confirm !== false) {


        const res = await http.post("api/platform/del", {id})

        if (res.code == 200) {
          this.getPlatformList();

          this.$dialog.tips({
            message: res.msg,
            type: 'success',
            position: 'top-center'
          })
          return;

        }

        this.$dialog.tips({
          message: res.msg,
          type: 'error',
          position: 'top-center'
        })

      }

    },
    async switchAccount(id) {

      const confirm = await this.$dialog.confirm({
        title: '温馨提示',
        message: '确定要切换至当前账号？'
      }).catch(() => false);

      if (confirm !== false) {
        const res = await http.post("api/platform/select", {id})
        if (res.code == 200) {
          this.getPlatformList();
          this.$parent.getUser();
          this.$dialog.tips({
            message: res.msg,
            type: 'success',
            position: 'top-center'
          })
          return;
        }
        this.$dialog.tips({
          message: res.msg,
          type: 'error',
          position: 'top-center'
        })
      }
    },
    openLogin() {
      switch (this.$store.state.userInfo.select_type) {
        case "douyin":
          window.open('https://buyin.jinritemai.com/mpa/account/login', '_blank')
          break;
        case "tiktok":
          window.open('https://shop.tiktok.com/streamer/live/product/dashboard', '_blank')
          break;
      }
    },
  }
}
</script>

<style scoped>
.account-management {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  position: relative;
  overflow: hidden;
}


.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 17px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

.account-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 17px;
}

.account-list-item {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(40, 40, 40, 0.9) 0%, rgba(30, 30, 30, 0.9) 100%);
  border-radius: 12px;
  padding: 17px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(60, 60, 60, 0.5);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.account-list-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #8b5cf6 0%, #22d3ee 100%);
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.3s ease;
}

.account-list-item:hover {
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);
  border-color: rgba(139, 92, 246, 0.4);
}

.account-list-item:hover::before {
  transform: scaleY(1);
}

.account-list-item.is-current {
  border-color: rgba(16, 185, 129, 0.5);
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
}

.account-list-item.is-current::before {
  background: linear-gradient(180deg, #10b981 0%, #34d399 100%);
  transform: scaleY(1);
}

.current-account-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.15) 100%);
  border-radius: 12px;
  font-size: 12px;
  color: #34d399;
  margin-top: 6px;
  border: 1px solid rgba(16, 185, 129, 0.3);
  font-weight: 500;
}

.current-account-tag i {
  font-size: 11px;
}

.account-index {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  margin-right: 16px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.account-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 20px;
  border: 2px solid rgba(139, 92, 246, 0.5);
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.2);
}

.account-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-info {
  flex: 1;
}

.account-info .account-name {
  font-size: 16px;
  font-weight: 600;
  color: #e8e8e8;
  margin: 0;
}

.account-actions {
  display: flex;
  gap: 8px;
}

.account-actions .btn {
  padding: 6px 12px;
  font-size: 12px;
}

/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.modal-content {
  width: 100%;
  max-width: 400px;
  background: rgba(30, 30, 35, 0.98);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: slideUp 0.3s ease;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e8e8e8;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 18px;
  transition: color 0.3s;
}

.modal-close:hover {
  color: #e8e8e8;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  background: rgba(25, 25, 30, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.15);
  border-radius: 10px;
  color: #e8e8e8;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 15px rgba(139, 92, 246, 0.15);
}

.modal-footer {
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid rgba(139, 92, 246, 0.3);
  background: rgba(139, 92, 246, 0.1);
  color: #a78bfa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.page-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%);
  color: #fff;
  border-color: #8b5cf6;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  border-color: rgba(100, 100, 100, 0.3);
  background: rgba(50, 50, 50, 0.5);
  color: #666;
}

.page-info {
  font-size: 14px;
  color: #a0a0a0;
}

.btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(200, 200, 200, 0.15);
  transition: left 0.3s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 0;
}

.btn-primary {
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 50%, #4f46e5 100%);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

</style>
